import { Component, Input } from '@angular/core';
import MessagesActionsService from '../services/messages-actions.service';
import { hiddenElementSlideInOut } from '../animations/slides.animation';

@Component({
  selector: 'info-banner',
  templateUrl: './info-banner.component.html',
  animations: [hiddenElementSlideInOut]
})
export class InfoBannerComponent {
  @Input()
  infoBannerData: any = {};
  isVisible = true;

  constructor(
    private messagesActionsService: MessagesActionsService,
  ) {
  }

  removeMessage(event: Event) {
    event.preventDefault();

    this.messagesActionsService.deleteMessage(this.infoBannerData.uid);
    this.isVisible = false;
  }
}
